import React, { useState } from 'react'
import { useLocation } from 'react-router-dom'
import { classNames } from 'primereact/utils'
import { BreadCrumb } from 'primereact/breadcrumb'
import { Button } from 'primereact/button'
import { InputText } from 'primereact/inputtext'

const AppBreadcrumb = (props) => {
  const [search, setSearch] = useState('')
  const location = useLocation()

  const activeRoute = props.routes.filter((route) => {
    return (
      removerAcentos(route.label.replace(/\s/g, '').toLowerCase()) ===
      removerAcentos(
        location.pathname.toLowerCase().replace(/\s/g, '').slice(1)
      )
    )
  })

  let items

  if (location.pathname === '/') {
    items = [
      { label: 'Inicio' },
      { label: JSON.parse(localStorage.getItem('@usuario')).empresa },
    ]
  } else if (!activeRoute.length) {
    items = [{ label: '' }, { label: '' }]
  } else {
    items = [{ label: activeRoute[0].parent }, { label: activeRoute[0].label }]
  }

  const isStatic = () => {
    return props.menuMode === 'static'
  }

  function removerAcentos(str) {
    // Mapeia os caracteres acentuados e suas correspondências sem acentos
    const mapaAcentos = {
      á: 'a',
      à: 'a',
      â: 'a',
      ã: 'a',
      ä: 'a',
      é: 'e',
      è: 'e',
      ê: 'e',
      ë: 'e',
      í: 'i',
      ì: 'i',
      î: 'i',
      ï: 'i',
      ó: 'o',
      ò: 'o',
      ô: 'o',
      õ: 'o',
      ö: 'o',
      ú: 'u',
      ù: 'u',
      û: 'u',
      ü: 'u',
      ç: 'c',
      Á: 'A',
      À: 'A',
      Â: 'A',
      Ã: 'A',
      Ä: 'A',
      É: 'E',
      È: 'E',
      Ê: 'E',
      Ë: 'E',
      Í: 'I',
      Ì: 'I',
      Î: 'I',
      Ï: 'I',
      Ó: 'O',
      Ò: 'O',
      Ô: 'O',
      Õ: 'O',
      Ö: 'O',
      Ú: 'U',
      Ù: 'U',
      Û: 'U',
      Ü: 'U',
      Ç: 'C',
    }

    // Usa a expressão regular para substituir os caracteres acentuados pelas suas correspondências sem acentos
    return str.replace(
      /[áàâãäéèêëíìîïóòôõöúùûüçÁÀÂÃÄÉÈÊËÍÌÎÏÓÒÔÕÖÚÙÛÜÇ]/g,
      function (match) {
        return mapaAcentos[match]
      }
    )
  }

  return (
    <div className='layout-breadcrumb-container'>
      <div className='layout-breadcrumb-left-items'>
        {isStatic() && (
          <button
            className='menu-button p-link'
            onClick={props.onMenuButtonClick}
          >
            <i className='pi pi-bars'></i>
          </button>
        )}

        <BreadCrumb model={items} className='layout-breadcrumb' />
      </div>
    </div>
  )
}

export default AppBreadcrumb
